module.exports = __webpack_public_path__ + "static/media/NoAvatar.e62879b4.png";